import { useClientSubscriptions } from 'hooks/useClientSubscriptions'

interface Props {
  programId?: string | undefined
  userId?: string | undefined
}

export const useHasPremiumAccess = ({ programId, userId }: Props) => {
  const { data: subscriptions = [] } = useClientSubscriptions({
    userId,
  })

  if (!programId || !userId) return false
  return subscriptions.some((sub) => sub.program.id === programId)
}
